import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {ILot} from "../../../../../../utils/interfaces/tannery_raw_material/ILot";

const useApiToggleLotClose = (companyToken: string | undefined): UseMutationResult<ILot, CustomAxiosError, {
    id: number;
}, unknown> => {
    const {put} = useApiCalls();
    const queryClient = useQueryClient();

    async function doToggle(company_token: string | undefined, id: number): Promise<ILot> {
        try {
            const response = await put(`/api/company/${company_token}/tannery_raw_material/lots/${id}/toggle_close/`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<ILot, CustomAxiosError, {
        id: number;
    }>({
        mutationFn: ({id}) => doToggle(companyToken, id),
        onSuccess: (data, variables) => {
            queryClient.setQueryData<ILot[]>(['getLots'], (old) => {
                if (!old) return [];
                return old.map(lot =>
                    lot.id === variables.id
                        ? {
                            ...lot,
                            manually_closed_at: data.manually_closed_at
                        }
                        : lot
                );
            });
        }
    });
};

export default useApiToggleLotClose;